import { Component, OnInit,ViewChild } from '@angular/core';
import { CavaliService } from 'app/services/Cavali/Cavali.service';
import { MatTableDataSource, MatPaginator, MatSort,DateAdapter,MAT_DATE_FORMATS,MAT_DATE_LOCALE} from '@angular/material';
import { Observable } from 'rxjs/Rx';
import { startWith, map } from 'rxjs/operators';
import { FormControl, FormGroup} from '@angular/forms';
import { DatePipe } from '@angular/common';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { LoginService } from "../../services/login/login.service";
import { environment } from 'environments/environment'; 


export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "DD-MM-YYYY",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

@Component({
  selector: 'app-listado-cavali',
  templateUrl: './listado-cavali.component.html',
  styleUrls: ['./listado-cavali.component.scss'],
  providers: [
    DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class ListadoCavaliComponent implements OnInit {

  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;  
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  pageSizeOptions = [15,20,30,50,100,200];
  displayedColumns : string[] = ['idComprobante','RUT','Participante','Proveedor','RucProveedor','Adquirente','RucAdquirente','FechaRegistro','TipoComprobante','TipoEmision','Documento','CodigodeValor','TipoConformidad','FechaConformidad','FechaTransferencia','Moneda','VNPPICLV','FechadePagoICLV','Estado'];
  
  dataSource : any; 

  proveedoresArr : any;
  adquirentesArr : any;

  loading : boolean;
  documentosCavali : any = [];

  filteredProveedores : Observable<any[]>;
  filteredAdquirentes: Observable<any[]>;
  
  filterForm =  new FormGroup({
    provFilter: new FormControl(''),
    adqFilter: new FormControl(''),
    
    tipoFilter: new FormControl(''),
    idProvFilter: new FormControl(''),
    idAdqFilter: new FormControl(''),
    estadoFilter: new FormControl(''),
    tipoFechaFilter: new FormControl(''),
    fromDate: new FormControl(),
    toDate: new FormControl()
  });

  filterValues = {
    Tipo: '',
    Proveedor: '',
    Adquirente: '',
    Estado: '',
    Fecha: '',
    From: '',
    To: ''
  };

  constructor(private cavaliService : CavaliService,private loginService:LoginService,private datepipe:DatePipe) {
    this.obtenerProveedoresCombo(); 
    this.obtenerAdquirentesCombo();
    this.listarCavali();
  }

  ngOnInit() {
    this.filterForm.get('tipoFilter').valueChanges.subscribe(
      tipo => {
        this.filterValues.Tipo = tipo;
        this.dataSource.filter = JSON.stringify(this.filterValues);
      }
    );  
    this.filterForm.get('idProvFilter').valueChanges.subscribe(
      idProveedor => {
        this.filterValues.Proveedor = idProveedor;
        this.dataSource.filter = JSON.stringify(this.filterValues);
      }
    );
    this.filterForm.get('idAdqFilter').valueChanges.subscribe(
      idAdquirente => {
        this.filterValues.Adquirente = idAdquirente;
        this.dataSource.filter = JSON.stringify(this.filterValues);
      }
    ); 
    this.filterForm.get('estadoFilter').valueChanges.subscribe(
      estado => {
        this.filterValues.Estado = estado;
        this.dataSource.filter = JSON.stringify(this.filterValues);
      }
    );
    this.filterForm.get('tipoFechaFilter').valueChanges.subscribe(
      fecha => {
        this.filterValues.Fecha = fecha;
        this.dataSource.filter = JSON.stringify(this.filterValues);
      }
    );
    this.filterForm.get('fromDate').valueChanges.subscribe(
      from => {
        this.filterValues.From = (from === null ? "" : this.datepipe.transform(from, 'yyyy-MM-dd'));
        this.dataSource.filter = JSON.stringify(this.filterValues);
      }
    );
    this.filterForm.get('toDate').valueChanges.subscribe(
      to => {
        this.filterValues.To = (to === null ? "" : this.datepipe.transform(to, 'yyyy-MM-dd')); 
        this.dataSource.filter = JSON.stringify(this.filterValues);
      }
    );
  }

  clickGuard(){
    this.loginService.clickGuard = true;
  }

  createFilter(): (data: any, filter: string) => boolean {
    let filterFunction = function(data, filter): boolean {
      let searchTerms = JSON.parse(filter);
      return  data.Tipo_Comprobante.toString().toUpperCase().indexOf(searchTerms.Tipo) !== -1
              && data.idProveedor === (searchTerms.Proveedor == "" ? data.idProveedor : searchTerms.Proveedor)
              && data.idAdquirente === (searchTerms.Adquirente == "" ? data.idAdquirente : searchTerms.Adquirente)
              && data.Estado.toString().toUpperCase().indexOf(searchTerms.Estado) !== -1

              && data.Fecha_Registro >= (searchTerms.Fecha == "R" ? (searchTerms.From == "" ? data.Fecha_Registro : searchTerms.From) : data.Fecha_Registro)
              && data.Fecha_Registro <= (searchTerms.Fecha == "R" ? (searchTerms.To == "" ? data.Fecha_Registro : searchTerms.To) : data.Fecha_Registro)

              && data.Fecha_Conformidad >= (searchTerms.Fecha == "C" ? (searchTerms.From == "" ? data.Fecha_Conformidad : searchTerms.From) : data.Fecha_Conformidad)
              && data.Fecha_Conformidad <= (searchTerms.Fecha == "C" ? (searchTerms.To == "" ? data.Fecha_Conformidad : searchTerms.To) : data.Fecha_Conformidad)

              && data.Fecha_Transferencia >= (searchTerms.Fecha == "T" ? (searchTerms.From == "" ? data.Fecha_Transferencia : searchTerms.From) : data.Fecha_Transferencia)
              && data.Fecha_Transferencia <= (searchTerms.Fecha == "T" ? (searchTerms.To == "" ? data.Fecha_Transferencia : searchTerms.To) : data.Fecha_Transferencia)

              && data.Fecha_de_Pago_ICLV >= (searchTerms.Fecha == "P" ? (searchTerms.From == "" ? data.Fecha_de_Pago_ICLV : searchTerms.From) : data.Fecha_de_Pago_ICLV)
              && data.Fecha_de_Pago_ICLV <= (searchTerms.Fecha == "P" ? (searchTerms.To == "" ? data.Fecha_de_Pago_ICLV : searchTerms.To) : data.Fecha_de_Pago_ICLV)
    }
    return filterFunction;
  }

  obtenerProvId(provId :string){
    this.filterForm.get('idProvFilter').setValue(provId);
  }

  obtenerAdqId(adqId :string){
    this.filterForm.get('idAdqFilter').setValue(adqId);
  }

  private cleanControls(){
    this.filterForm.get('provFilter').setValue('');
    this.filterForm.get('adqFilter').setValue('');
    this.filterForm.get('tipoFilter').setValue('');
    this.filterForm.get('idProvFilter').setValue('');
    this.filterForm.get('idAdqFilter').setValue('');
    this.filterForm.get('estadoFilter').setValue('');
    this.filterForm.get('tipoFechaFilter').setValue('');
    this.filterForm.get('fromDate').setValue(null);
    this.filterForm.get('toDate').setValue(null);
  }

  listarCavali(){
    this.loading = true;
    this.cavaliService.listarCavali().subscribe( 
      resp => { 
        this.documentosCavali = resp['data'];
        this.dataSource = new MatTableDataSource(this.documentosCavali);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.dataSource.filterPredicate = this.createFilter();
        this.cleanControls();
        this.loading = false;
      },err => {
        this.loading = false;
      }
    )
  }

  obtenerRucRazSocialProv(termino: string = ''){
    if (termino != null && termino != ''){
      termino = termino.toLowerCase();                  
      for(let p of this.proveedoresArr){
        let raz = p.Razon_Social.toLocaleLowerCase();
        let ruc = p.Num_Doc_Identificacion;
        if (raz.indexOf(termino) >= 0 || ruc.indexOf(termino) >= 0){
          this.filterForm.get('idProvFilter').setValue(p.idEmpresa);
          this.filterForm.get('provFilter').setValue(p.Razon_Social);
          break;
        }
      }
    } else {
      this.filterForm.get('idProvFilter').setValue('');
      this.filterForm.get('provFilter').setValue('');
    }
  }

  obtenerRucRazSocialAdq(termino: string = ''){
    if (termino != null && termino != ''){          
      termino = termino.toLowerCase();                
      for(let p of this.adquirentesArr){
          let raz = p.Razon_Social.toLocaleLowerCase();
          let ruc = p.Num_Doc_Identificacion;
        if (raz.indexOf(termino) >= 0 || ruc.indexOf(termino) >= 0){
          this.filterForm.get('idAdqFilter').setValue(p.idEmpresa);
          this.filterForm.get('adqFilter').setValue(p.Razon_Social);
          break;
        }
      }
    } else {
      this.filterForm.get('idAdqFilter').setValue('');
      this.filterForm.get('adqFilter').setValue('');
    }
  }

  obtenerProveedoresCombo(){
    this.proveedoresArr = JSON.parse(sessionStorage.getItem('lstProvCbo'));
    this.filteredProveedores = this.filterForm.get('provFilter').valueChanges.pipe(
      startWith(""),
      map(state => state ? this._filterProv(state) : this.proveedoresArr.slice())
    );   
  }

  private _filterProv(value: string): any[] {
    const filterValue = value.toString().toLowerCase();

    return this.proveedoresArr.filter(
      state => state.Razon_Social.toLowerCase().includes(filterValue) === true ||
      state.Num_Doc_Identificacion.includes(filterValue) === true
    );
  }

  obtenerAdquirentesCombo(){
    this.adquirentesArr = JSON.parse(sessionStorage.getItem('lstAdqCbo'));
    this.filteredAdquirentes = this.filterForm.get('adqFilter').valueChanges.pipe(
      startWith(""),
      map(state => state ? this._filterAdq(state) : this.adquirentesArr.slice())
    );  
  }

  private _filterAdq(value: string): any[] {
    const filterValue = value.toString().toLowerCase();

    return this.adquirentesArr.filter(
      state => state.Razon_Social.toLowerCase().includes(filterValue) === true ||
      state.Num_Doc_Identificacion.includes(filterValue) === true
    );
  }
}
